import React from 'react';
import { Link } from 'react-router-dom';
import { calculatorConfig, isCalculatorAccessible } from '../config/features';

/**
 * NotFound — rendered for any unmatched route. SEOHead emits
 * noindex for this page via the notFound pageInfo in App.js.
 */
const NotFound = () => {
  const suggestions = Object.entries(calculatorConfig).filter(
    ([, calc]) => isCalculatorAccessible(calc) && !calc.excludeFromLandingGrid && calc.path !== '/logs'
  );

  return (
    <div className="w-full max-w-2xl mx-auto py-8 text-center">
      <h1 className="font-headline font-bold text-2xl text-ink mb-2">Page not found</h1>
      <p className="text-sm text-ink-secondary leading-relaxed mb-6">
        The page you're looking for doesn't exist or may have moved.
        Head back to the <Link to="/" className="text-conform-red hover:text-conform-yellow font-medium">home page</Link> or
        jump straight into a calculator:
      </p>
      <ul className="flex flex-wrap justify-center gap-2">
        {suggestions.map(([key, calc]) => (
          <li key={key}>
            <Link
              to={calc.path}
              className="inline-block px-3 py-1.5 rounded-lg border border-border text-sm text-ink hover:border-conform-yellow/40 hover:text-conform-yellow transition-colors no-underline"
            >
              {calc.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotFound;
